/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import classNames from 'classnames';
import React from 'react';

import ProteinActions from 'molbio/proteins/ProteinActions';
import ProteinAnnotationEditorActions from 'molbio/proteins/ProteinAnnotationEditorActions';
import {Protein} from 'molbio/proteins/util/ProteinConstants';
import * as sequtil from 'molbio/SeqUtil';
import getTestProps from 'test/lib/cypress/getTestProps';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import sortedBy from 'util/sortedBy';

interface ProteinAnnotationRowProps {
  proteinId: string;
  id: string;
  name: string;
  displayStart: number;
  displayEnd: number;
  length: number;
  color: string;
  selected: boolean;
  hover: boolean;
  disabled: boolean;
}

class ProteinAnnotationRow extends React.Component<ProteinAnnotationRowProps> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleDelete = (e: any) => {
    e.stopPropagation();
    ProteinAnnotationEditorActions.delete(this.props.proteinId, this.props.id);
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleClick = () => {
    ProteinActions.selectAnnotation(this.props.proteinId, this.props.id);
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleMouseEnter = () => {
    ProteinActions.hoverAnnotation(this.props.proteinId, this.props.id);
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleMouseLeave = () => {
    ProteinActions.unhoverAnnotation(this.props.proteinId, this.props.id);
  };

  render(): JSX.Element {
    const {name, displayStart, displayEnd, length, color, selected, hover, disabled} = this.props;
    return (
      <tr
        className={classNames({
          'proteinAnnotationsPanel-row--selected': selected,
          'proteinAnnotationsPanel-row--hover': hover,
        })}
        onClick={this._handleClick}
        onMouseEnter={this._handleMouseEnter}
        onMouseLeave={this._handleMouseLeave}
      >
        <td className="proteinAnnotationsPanel-cell">{name}</td>
        <td className="proteinAnnotationsPanel-cell">
          {displayStart} - {displayEnd}
        </td>
        <td className="proteinAnnotationsPanel-cell">{length}</td>
        <td className="proteinAnnotationsPanel-cell">
          <div className="swatch" style={{backgroundColor: color}} />
        </td>
        <td className="proteinAnnotationsPanel-cell">
          <a
            className={classNames('faded u-danger-pointer', {
              'proteinAnnotationsPanel-deleteButton--notHover': !hover || disabled,
            })}
            onClick={this._handleDelete}
          >
            <BenchlingIcon icon="delete" />
          </a>
        </td>
      </tr>
    );
  }
}

interface ProteinAnnotationsTableProps {
  protein: Protein;
  selectedAnnotationId?: string;
  hoverAnnotationId?: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const ProteinAnnotationsTable = ({
  protein,
  selectedAnnotationId,
  hoverAnnotationId,
}: ProteinAnnotationsTableProps) => {
  const proteinStartIndex = 1;
  const proteinLength = protein.version.aminoAcids.length;
  const rowData = protein.version.annotations.map(({id, name, start, end, color}) => ({
    id,
    name,
    displayStart: sequtil.modelToDisplay(start, proteinStartIndex),
    displayEnd: sequtil.modelEndToDisplay(end, proteinLength, proteinStartIndex),
    length: sequtil.length(start, end, proteinLength),
    color,
  }));

  const sortedRows = sortedBy(rowData, ['displayStart', 'displayEnd']);

  const rows = sortedRows.map(({id, name, displayStart, displayEnd, length, color}) => (
    <ProteinAnnotationRow
      key={id}
      proteinId={protein.id}
      id={id}
      name={name}
      displayStart={displayStart}
      displayEnd={displayEnd}
      length={length}
      color={color}
      selected={selectedAnnotationId === id}
      hover={hoverAnnotationId === id}
      disabled={!protein.permissions.polymerFeaturesEditable}
    />
  ));
  return (
    <div className="scroll" {...getTestProps({component: 'ProteinAnnotationsTable', element: 'root'})}>
      <table className="proteinAnnotationsPanel-table u-width-full">
        <thead className="proteinAnnotationsPanel-header">
          <tr>
            <th className="proteinAnnotationsPanel-cell">Name</th>
            <th className="proteinAnnotationsPanel-cell">Location</th>
            <th className="proteinAnnotationsPanel-cell">Length</th>
            <th className="proteinAnnotationsPanel-cell" />
            <th className="proteinAnnotationsPanel-cell" />
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
      {rows.length === 0 && <span className="proteinAnnotationsPanel-emptyMessage">No annotations.</span>}
    </div>
  );
};

export default ProteinAnnotationsTable;
